<div class="wiki-main-container">
  @if ((loading$ | async) === false) {
    @if (wikiGroups$ | async; as wikiGroups) {
      <wiki-toolbar [wikiGroups]="wikiGroups"></wiki-toolbar>
      <wiki-list [wikiGroups]="wikiGroups" [randomColors]="randomColors()"></wiki-list>
    }
  } @else {
    <div class="oph-loading-container">
      <oph-loading></oph-loading>
    </div>
  }
</div>

<oph-drawer #drawer />
